import { MeterPlacement } from '@enmon/commons/lib/enmon';
import { Commodity } from '@enmon/commons/lib/shared';
import type { MeterPlacementSelection } from '@/features/inventorization/domain/inventorization-identity';
import {
  formatInventorizationCommodity,
  formatInventorizationPlacement,
  INVENTORIZATION_NEW_METER_SELECTIONS,
  type InventorizationNewMeterSelection,
} from '@/features/inventorization/domain/inventorization-identity';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

const inventorizationPlacementValues: MeterPlacementSelection[] = [MeterPlacement.Main, MeterPlacement.Secondary];

const inventorizationNewMeterValues: InventorizationNewMeterSelection[] = [
  INVENTORIZATION_NEW_METER_SELECTIONS.existing,
  INVENTORIZATION_NEW_METER_SELECTIONS.newSubmeterSuggestion,
];

export function getInventorizationPlacementOptions(): Array<{ label: string; value: MeterPlacementSelection }> {
  return inventorizationPlacementValues.map(value => ({
    label: formatInventorizationPlacement(value),
    value,
  }));
}

export function getInventorizationNewMeterOptions(): Array<{
  label: string;
  value: InventorizationNewMeterSelection;
}> {
  return inventorizationNewMeterValues.map(value => ({
    label:
      value === INVENTORIZATION_NEW_METER_SELECTIONS.existing
        ? translateInventoryText('app.inventory.identity.newMeter.existing', 'Existing meter')
        : translateInventoryText('app.inventory.identity.newMeter.newSubmeterSuggestion', 'New submeter suggestion'),
    value,
  }));
}

const inventorizationCommodityOrder = [
  Commodity.Electricity,
  Commodity.Water,
  Commodity.NaturalGas,
  Commodity.Thermal,
  Commodity.Other,
] as const;

const inventorizationCommodityShortLabels: Record<(typeof inventorizationCommodityOrder)[number], string> = {
  [Commodity.Electricity]: 'E',
  [Commodity.NaturalGas]: 'G',
  [Commodity.Other]: 'O',
  [Commodity.Thermal]: 'T/C',
  [Commodity.Water]: 'W',
};

export function getInventorizationCommodityOptions(): Array<{
  label: string;
  shortLabel: string;
  value: Commodity;
}> {
  return inventorizationCommodityOrder.map(value => ({
    label: formatInventorizationCommodity(value),
    shortLabel: inventorizationCommodityShortLabels[value],
    value,
  }));
}
